export default "__VITE_ASSET__BqM0rgic__"